import {
  fetchRecommendedVoices as apiFetchRecommendedVoices,
  sendVoiceChatMessage as apiSendVoiceChatMessage,
} from 'setup/redux/Actions/Chatbot/chatbot'

export const fetchRecommendedVoices = async (signal?: AbortSignal) => {
  return apiFetchRecommendedVoices(signal)
}

export const sendVoiceChatMessage = async (audioBlob: Blob, opts?: any) => {
  return apiSendVoiceChatMessage(audioBlob, opts)
}
